import React from 'react';

// Connection state for a Kick chat feed: "Connection lost" with a button once retries give up,
// "Reconnecting..." while (re)connecting, nothing when connected.
const KickConnectionBanner = ({ status, onReconnect }) => {
  if (status === 'failed') {
    return (
      <div
        className="chat-connection-status error"
      >
        <span>Connection lost</span>
        <button
          onClick={onReconnect}
        >
          Reconnect
        </button>
      </div>
    );
  }

  if (status === 'connecting' || status === 'reconnecting') {
    return (
      <div
        className="chat-connection-status reconnect"
      >
        Reconnecting...
      </div>
    );
  }

  return null;
};

export default KickConnectionBanner;
